import { type ColumnType } from 'antd/es/table';
import { type ColumnTitleProps } from 'antd/es/table/interface';
import type * as React from 'react';
import { ColumnPickerHeaderCell } from './ColumnPickerHeaderCell.tsx';

export const SETTING_COLUMN_KEY = 'action';

export function addColumnPicker<T>(
  columns?: Array<ColumnType<T>>,
  button?: React.ReactNode,
) {
  if (!columns) {
    return [];
  }
  return columns.map(column => {
    if (column.key === SETTING_COLUMN_KEY) {
      return {
        ...column,
        // Questo verrebbe aggiunto solamente se c'è il ColumnPicker.
        // Usiamo le funzioni in `PickableColumnUtils` per aggiungere il fixed,
        // dato che vengono chiamate sempre.
        // fixed: 'right' as const,

        title: (props: ColumnTitleProps<T>) => {
          return (
            <ColumnPickerHeaderCell<T>
              column={column}
              titleProps={props}
              button={button}
            />
          );
        },
      };
    }
    return column as ColumnType<T>;
  });
}
